var map = {
	"./alert/balance.png": 1693,
	"./alert/learning.png": 6979,
	"./alert/social.png": 3412,
	"./avtar/11.jpg": 6067,
	"./avtar/16.jpg": 4416,
	"./avtar/3.jpg": 4614,
	"./avtar/4.jpg": 957,
	"./avtar/7.jpg": 3154,
	"./banner/1.jpg": 226,
	"./banner/2.jpg": 6157,
	"./banner/3.jpg": 3936,
	"./big-lightgallry/01.jpg": 6380,
	"./big-lightgallry/010.jpg": 2878,
	"./big-lightgallry/011.jpg": 9339,
	"./big-lightgallry/012.jpg": 1644,
	"./big-lightgallry/013.jpg": 5369,
	"./big-lightgallry/014.jpg": 6426,
	"./big-lightgallry/015.jpg": 5431,
	"./big-lightgallry/016.jpg": 6504,
	"./big-lightgallry/02.jpg": 1035,
	"./big-lightgallry/03.jpg": 2990,
	"./big-lightgallry/04.jpg": 8613,
	"./big-lightgallry/05.jpg": 7944,
	"./big-lightgallry/06.jpg": 4279,
	"./big-lightgallry/07.jpg": 6538,
	"./big-lightgallry/08.jpg": 7649,
	"./big-lightgallry/09.jpg": 5844,
	"./big-masonry/1.jpg": 1302,
	"./big-masonry/10.jpg": 4764,
	"./big-masonry/11.jpg": 1641,
	"./big-masonry/12.jpg": 1374,
	"./big-masonry/13.jpg": 9419,
	"./big-masonry/14.jpg": 6328,
	"./big-masonry/15.jpg": 6997,
	"./big-masonry/2.jpg": 9073,
	"./big-masonry/3.jpg": 548,
	"./big-masonry/4.jpg": 2511,
	"./big-masonry/5.jpg": 6162,
	"./big-masonry/6.jpg": 4653,
	"./big-masonry/7.jpg": 1200,
	"./big-masonry/8.jpg": 6107,
	"./big-masonry/9.jpg": 9646,
	"./blog/12.png": 5140,
	"./blog/14.png": 8930,
	"./blog/4.jpg": 6553,
	"./blog/9.jpg": 6608,
	"./blog/blog-2.jpg": 8052,
	"./blog/blog-3.jpg": 8001,
	"./blog/blog-5.jpg": 783,
	"./blog/blog-6.jpg": 464,
	"./blog/blog-single.jpg": 6240,
	"./blog/blog.jpg": 6617,
	"./blog/comment.jpg": 6526,
	"./blog/img.png": 4044,
	"./checkout/paypal.png": 2204,
	"./customizer/1.png": 5805,
	"./customizer/2.png": 4598,
	"./customizer/3.png": 3615,
	"./customizer/4.png": 7744,
	"./customizer/5.png": 3993,
	"./dashboard-2/balance-bg.png": 8664,
	"./dashboard-2/category/1.png": 9972,
	"./dashboard-2/category/2.png": 8783,
	"./dashboard-2/category/3.png": 3686,
	"./dashboard-2/dashboard-banner.gif": 8748,
	"./dashboard-2/headphones.png": 4597,
	"./dashboard-2/office-work.gif": 51,
	"./dashboard-2/order/1.png": 5478,
	"./dashboard-2/order/2.png": 9453,
	"./dashboard-2/order/3.png": 5556,
	"./dashboard-2/order/4.png": 1800,
	"./dashboard-2/order/5.png": 4594,
	"./dashboard-2/order/sub-product/1.png": 4207,
	"./dashboard-2/order/sub-product/10.png": 9839,
	"./dashboard-2/order/sub-product/2.png": 1748,
	"./dashboard-2/order/sub-product/3.png": 9229,
	"./dashboard-2/order/sub-product/4.png": 82,
	"./dashboard-2/order/sub-product/5.png": 3739,
	"./dashboard-2/order/sub-product/6.png": 8336,
	"./dashboard-2/order/sub-product/7.png": 4089,
	"./dashboard-2/order/sub-product/8.png": 8526,
	"./dashboard-2/order/sub-product/9.png": 2167,
	"./dashboard-2/product/1.png": 5055,
	"./dashboard-2/product/2.png": 3588,
	"./dashboard-2/product/3.png": 4717,
	"./dashboard-3/better.png": 205,
	"./dashboard-3/bg-1.png": 5376,
	"./dashboard-3/bg-2.png": 5227,
	"./dashboard-3/bg-3.png": 7746,
	"./dashboard-3/bg-balance.png": 2593,
	"./dashboard-3/bg.jpg": 6470,
	"./dashboard-3/boostup1.png": 4460,
	"./dashboard-3/boostup2.png": 8391,
	"./dashboard-3/follower.png": 7441,
	"./dashboard-3/mobile-img.png": 9487,
	"./dashboard-3/product/1.png": 4474,
	"./dashboard-3/product/2.png": 721,
	"./dashboard-3/product/3.png": 2328,
	"./dashboard-3/product/4.png": 1943,
	"./dashboard-3/profile-bg.png": 6018,
	"./dashboard-3/profile.png": 3244,
	"./dashboard-3/social/1.png": 8542,
	"./dashboard-3/social/2.png": 341,
	"./dashboard-3/social/3.png": 924,
	"./dashboard-3/social/4.png": 4531,
	"./dashboard-3/user.png": 7322,
	"./dashboard-3/wave.png": 3816,
	"./dashboard-bg.webp": 186,
	"./dashboard.jpg": 4186,
	"./dashboard/Banner.png": 8873,
	"./dashboard/Dashboard-Ecommerce-banner.gif": 5886,
	"./dashboard/folder.png": 2807,
	"./dashboard/folder1.png": 1838,
	"./dashboard/order-table/1.png": 8896,
	"./dashboard/order-table/2.png": 7227,
	"./dashboard/order-table/3.png": 2402,
	"./dashboard/order-table/4.png": 7261,
	"./dashboard/order-table/5.png": 3364,
	"./dashboard/order-table/6.png": 223,
	"./dashboard/order-table/7.png": 3286,
	"./dashboard/order-table/8.png": 593,
	"./dashboard/order-table/9.png": 376,
	"./dashboard/profile.png": 4420,
	"./dashboard/user/1.jpg": 3362,
	"./dashboard/user/10.jpg": 4880,
	"./dashboard/user/11.jpg": 6621,
	"./dashboard/user/12.jpg": 8818,
	"./dashboard/user/13.jpg": 5199,
	"./dashboard/user/2.jpg": 3261,
	"./dashboard/user/3.jpg": 2128,
	"./dashboard/user/4.jpg": 4963,
	"./dashboard/user/5.jpg": 8502,
	"./dashboard/user/6.jpg": 8849,
	"./dashboard/user/7.jpg": 804,
	"./dashboard/user/8.jpg": 5223,
	"./dashboard/user/9.jpg": 1386,
	"./dashboard/widget-bg.png": 2935,
	"./details_close.png": 3441,
	"./details_open.png": 2005,
	"./ecommerce/01.jpg": 7782,
	"./ecommerce/02.jpg": 7393,
	"./ecommerce/03.jpg": 9348,
	"./ecommerce/04.jpg": 5727,
	"./ecommerce/05.jpg": 9346,
	"./ecommerce/06.jpg": 8301,
	"./ecommerce/07.jpg": 9088,
	"./ecommerce/08.jpg": 1867,
	"./ecommerce/09.jpg": 558,
	"./ecommerce/10.jpg": 1300,
	"./ecommerce/11.jpg": 9825,
	"./ecommerce/12.jpg": 2054,
	"./ecommerce/13.jpg": 3107,
	"./ecommerce/14.jpg": 1952,
	"./ecommerce/15.jpg": 5405,
	"./ecommerce/16.jpg": 6914,
	"./ecommerce/Frame 34.svg": 8605,
	"./ecommerce/banner.jpg": 689,
	"./ecommerce/card.png": 6633,
	"./ecommerce/mastercard.png": 9007,
	"./ecommerce/order-trash.gif": 1353,
	"./ecommerce/payment-option/card.svg": 5974,
	"./ecommerce/payment-option/cash.svg": 4125,
	"./ecommerce/payment-option/wallet.svg": 7515,
	"./ecommerce/paypal.png": 6894,
	"./ecommerce/product-categories/drone.png": 2574,
	"./ecommerce/product-categories/dvd.png": 4862,
	"./ecommerce/product-categories/headphone.png": 8314,
	"./ecommerce/product-categories/ipad.png": 3502,
	"./ecommerce/product-categories/keyboard.png": 3469,
	"./ecommerce/product-categories/laptop.png": 5870,
	"./ecommerce/product-categories/mac-laptop.png": 9880,
	"./ecommerce/product-categories/mouse.png": 73,
	"./ecommerce/product-categories/phone.png": 656,
	"./ecommerce/product-categories/speaker.png": 11,
	"./ecommerce/product-categories/watch-2.png": 508,
	"./ecommerce/product-categories/watch.png": 8789,
	"./ecommerce/product-categories/wireless-headphone.png": 7471,
	"./ecommerce/product-png/product-table-1.png": 6221,
	"./ecommerce/product-png/product-table-2.png": 2217,
	"./ecommerce/product-png/product-table-3.png": 4575,
	"./ecommerce/product-png/product-table-4.png": 3248,
	"./ecommerce/product-png/product-table-5.png": 4425,
	"./ecommerce/product-png/product-table-6.png": 3714,
	"./ecommerce/product-table-1.png": 919,
	"./ecommerce/product-table-2.png": 6988,
	"./ecommerce/product-table-3.png": 2901,
	"./ecommerce/product-table-4.png": 2474,
	"./ecommerce/product-table-5.png": 4387,
	"./ecommerce/product-table-6.png": 8776,
	"./ecommerce/product-table-7.png": 9905,
	"./ecommerce/shop-categories/camera.png": 4558,
	"./ecommerce/shop-categories/dron.png": 5914,
	"./ecommerce/shop-categories/headphone.png": 6213,
	"./ecommerce/shop-categories/keyboard.png": 2236,
	"./ecommerce/shop-categories/laptop-bag.png": 1106,
	"./ecommerce/shop-categories/laptop.png": 471,
	"./ecommerce/shop-categories/mouse.png": 8578,
	"./ecommerce/shop-categories/phone.png": 2903,
	"./ecommerce/shop-categories/watch.png": 981,
	"./ecommerce/visa.png": 884,
	"./ecommerce/watch.png": 9330,
	"./email-template/10.jpg": 9955,
	"./email-template/11.jpg": 6790,
	"./email-template/3.png": 2545,
	"./email-template/4.png": 4830,
	"./email-template/invoice-1/1.png": 1457,
	"./email-template/invoice-1/sign.png": 5249,
	"./email-template/invoice-3/bg-0.png": 4498,
	"./email-template/invoice-3/sign.png": 1007,
	"./email-template/pdfs.png": 7921,
	"./email/1.jpg": 6986,
	"./email/2.jpg": 4213,
	"./email/3.jpg": 6600,
	"./eye-closed.svg": 1166,
	"./eye-open.svg": 1746,
	"./faq/1.jpg": 8398,
	"./faq/2.jpg": 7993,
	"./faq/3.jpg": 2732,
	"./faq/4.jpg": 2695,
	"./faq/learning-1.png": 3111,
	"./favicon.png": 170,
	"./forms/Bank-of-Baroda.png": 6326,
	"./forms/MasterCard.png": 8852,
	"./forms/SCB.png": 9986,
	"./forms/authenticate.png": 9159,
	"./forms/axis.png": 5287,
	"./forms/credit-card.png": 4396,
	"./forms/delivery.png": 3660,
	"./forms/email.png": 9582,
	"./forms/flags.png": 6287,
	"./forms/hdfc.png": 9493,
	"./forms/idbi.png": 1207,
	"./forms/qr-code.png": 7199,
	"./forms/qr-scan.png": 3859,
	"./forms/rbl.png": 66,
	"./forms/us-bank.png": 3245,
	"./forms/user.png": 2157,
	"./gif/danger.gif": 2467,
	"./gif/dashboard-8/successful.gif": 3378,
	"./gif/facebook.gif": 9202,
	"./gif/instagram.gif": 3462,
	"./gif/logout.gif": 2496,
	"./gif/online-shopping.gif": 8196,
	"./gif/qr-scan.gif": 6631,
	"./gif/whatapp.gif": 381,
	"./hand.gif": 5180,
	"./job-search/1.jpg": 2718,
	"./job-search/2.jpg": 7865,
	"./job-search/3.jpg": 76,
	"./job-search/4.jpg": 311,
	"./job-search/5.jpg": 8378,
	"./job-search/6.jpg": 5605,
	"./knowledgebase/bg_1.jpg": 8655,
	"./landing/bg-footer.png": 369,
	"./landing/demo-bg.png": 6989,
	"./lightgallry/01.jpg": 6399,
	"./lightgallry/010.jpg": 5695,
	"./lightgallry/011.jpg": 3986,
	"./lightgallry/012.jpg": 9917,
	"./lightgallry/013.jpg": 7696,
	"./lightgallry/014.jpg": 3971,
	"./lightgallry/015.jpg": 838,
	"./lightgallry/016.jpg": 8593,
	"./lightgallry/02.jpg": 2784,
	"./lightgallry/03.jpg": 8365,
	"./lightgallry/04.jpg": 550,
	"./lightgallry/05.jpg": 3715,
	"./lightgallry/06.jpg": 8436,
	"./lightgallry/07.jpg": 6481,
	"./lightgallry/08.jpg": 5338,
	"./lightgallry/09.jpg": 9799,
	"./lightgallry/default-skin.png": 6569,
	"./lightgallry/default-skin.svg": 4527,
	"./login-BG.webp": 1957,
	"./login-bg-v1.webp": 1993,
	"./login-bg-v1c1c2535010d6708f7586.webp": 6233,
	"./login-bg.jpg": 853,
	"./login/1.jpg": 6369,
	"./login/2.jpg": 4166,
	"./login/3.jpg": 4275,
	"./login/icon.png": 1997,
	"./login/login_bg.jpg": 7665,
	"./logo-footer.webp": 1195,
	"./logo.png": 2145,
	"./logo.webp": 2889,
	"./logo/3.png": 659,
	"./logo/logo-icon.png": 5485,
	"./logo/logo-rounded.png": 6075,
	"./logo/logo.png": 6447,
	"./logo/logo_dark.png": 1832,
	"./logo/patient-journey.webp": 1802,
	"./masonry/1.jpg": 1419,
	"./masonry/10.jpg": 4739,
	"./masonry/11.jpg": 3126,
	"./masonry/12.jpg": 2737,
	"./masonry/13.jpg": 4692,
	"./masonry/14.jpg": 7423,
	"./masonry/15.jpg": 1042,
	"./masonry/2.jpg": 6252,
	"./masonry/3.jpg": 601,
	"./masonry/4.jpg": 8506,
	"./masonry/5.jpg": 663,
	"./masonry/6.jpg": 7816,
	"./masonry/7.jpg": 8997,
	"./masonry/8.jpg": 2790,
	"./masonry/9.jpg": 1315,
	"./new-cream-logo.png": 7793,
	"./other-images/bg-profile.png": 3887,
	"./other-images/boxbg.jpg": 138,
	"./other-images/cart-img.jpg": 7562,
	"./other-images/coming-soon-bg.jpg": 1823,
	"./other-images/logo-login.png": 99,
	"./other-images/logo_dark.png": 9792,
	"./other-images/maintenance-bg.jpg": 8465,
	"./other-images/mountain.jpg": 9279,
	"./other-images/paypal.png": 3687,
	"./other-images/profile-style-img.png": 461,
	"./other-images/profile-style-img3.png": 4466,
	"./other-images/receiver-img.jpg": 8747,
	"./other-images/sea.jpg": 2389,
	"./other-images/sidebar-bg.jpg": 2270,
	"./product/1.png": 2983,
	"./product/10.png": 4167,
	"./product/11.png": 6478,
	"./product/12.png": 2229,
	"./product/13.png": 5692,
	"./product/14.png": 9507,
	"./product/15.png": 4282,
	"./product/2.png": 2924,
	"./product/3.png": 2021,
	"./product/4.png": 5514,
	"./product/category/1.png": 3624,
	"./product/category/2.png": 8115,
	"./product/category/3.png": 2906,
	"./product/category/4.png": 7573,
	"./product/category/5.png": 4508,
	"./product/category/purse.png": 24,
	"./product/category/shoes.png": 949,
	"./product/category/toy.png": 3077,
	"./range-slider/sprite-skin-modern.png": 9669,
	"./scrollbar/fashion1.jpg": 7160,
	"./scrollbar/fashion2.jpg": 1911,
	"./scrollbar/fashion3.jpg": 8074,
	"./scrollbar/fashion4.jpg": 8761,
	"./scrollbar/fashion5.jpg": 716,
	"./scrollbar/fashion6.jpg": 3515,
	"./search-not-found.png": 5379,
	"./simple-logo.png": 6628,
	"./slider/1.jpg": 1719,
	"./slider/10.jpg": 5639,
	"./slider/11.jpg": 9802,
	"./slider/2.jpg": 2792,
	"./slider/3.jpg": 53,
	"./slider/4.jpg": 9166,
	"./slider/5.jpg": 5627,
	"./slider/6.jpg": 7932,
	"./slider/7.jpg": 5305,
	"./slider/8.jpg": 5682,
	"./slider/9.jpg": 5679,
	"./social-app/post-1.png": 8543,
	"./social-app/post-2.png": 9031,
	"./social-app/post-3.png": 3454,
	"./social-app/post-4.png": 1169,
	"./social-app/post-5.png": 40,
	"./social-app/post-6.png": 5795,
	"./social-app/post-7.png": 586,
	"./social-app/post-8.png": 3533,
	"./social-app/post-9.png": 500,
	"./social-app/social-image.png": 8709,
	"./social-app/timeline-1.png": 1763,
	"./social-app/timeline-2.png": 9800,
	"./social-app/timeline-3.png": 929,
	"./social-app/timeline-4.png": 2446,
	"./start-conversion.jpg": 1037,
	"./switch/1.jpg": 2360,
	"./switch/2.jpg": 9639,
	"./switch/3.jpg": 2122,
	"./switch/4.jpg": 8585,
	"./switch/5.jpg": 3324,
	"./switch/6.jpg": 3947,
	"./switch/7.jpg": 8990,
	"./switch/8.jpg": 6733,
	"./switch/square-gray.png": 6710,
	"./switch/square.svg": 6044,
	"./user/1.jpg": 5585,
	"./user/10.jpg": 7341,
	"./user/11.png": 3044,
	"./user/12.png": 8159,
	"./user/14.png": 5385,
	"./user/15.png": 9136,
	"./user/150x150.jpg": 7912,
	"./user/16.png": 2955,
	"./user/17.png": 2450,
	"./user/18.png": 3829,
	"./user/19.png": 1564,
	"./user/2.jpg": 3382,
	"./user/2.png": 8661,
	"./user/20.png": 9016,
	"./user/21.png": 1729,
	"./user/22.png": 2746,
	"./user/23.png": 9859,
	"./user/24.png": 9900,
	"./user/25.png": 7413,
	"./user/26.png": 4990,
	"./user/27.png": 8631,
	"./user/28.png": 4800,
	"./user/29.png": 553,
	"./user/3.jpg": 3491,
	"./user/3.png": 2171,
	"./user/30.png": 5971,
	"./user/31.png": 6138,
	"./user/32.png": 2385,
	"./user/33.png": 3992,
	"./user/34.png": 3607,
	"./user/35.png": 7822,
	"./user/38.png": 587,
	"./user/39.png": 5394,
	"./user/4.jpg": 4688,
	"./user/4.png": 2260,
	"./user/40.png": 318,
	"./user/41.png": 5895,
	"./user/42.png": 7788,
	"./user/43.png": 677,
	"./user/44.png": 3802,
	"./user/45.png": 2659,
	"./user/46.png": 6904,
	"./user/47.png": 8033,
	"./user/49.png": 1855,
	"./user/5.jpg": 9581,
	"./user/50.png": 489,
	"./user/51.png": 5664,
	"./user/52.png": 699,
	"./user/53.png": 5346,
	"./user/54.png": 6909,
	"./user/6.jpg": 354,
	"./user/7.jpg": 2063,
	"./user/8.jpg": 4316,
	"./user/9.jpg": 4841,
	"./user/user-dp.png": 8810,
	"./user/user.png": 7907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;